module.exports = __webpack_public_path__ + "static/media/GIN.6cf74d63.svg";